function readyCurrentForm(step) {
  jQuery(`#next-btn-loader-step-${step}`).show()
  jQuery(`#next-btn-content-step-${step}`).hide()

  let formUuid = localStorage.getItem("form-uuid")
  if (!formUuid) {
    formUuid = jQuery("#form-step-container").data("uuid")
    localStorage.setItem("form-uuid", formUuid)
  }

  const formElement = document.getElementById(`form-step-${step}`)
  const formData = new FormData(formElement)
  const data = Object.fromEntries(formData)
  data.uuid = formUuid
  data.ip = getFromStorage("ip")

  if (step == 1) {
    checkFirstStep(data)
  } else if (step == 5) {
    lastStepSendData(data)
  } else {
    showNextForm(step + 1, data)
  }
}

function checkFirstStep(data) {
  setTimeout(() => {
    checkSecurity(data)
  }, 200)
}

function lastStepSendData(data) {
  setTimeout(() => {
    showLoadingScreen(true)
    sendLead(data)
  }, 200)
}

function showNextForm(step, data) {
  setTimeout(() => {
    setMultiformData(step, data, "next")
  }, 200)
}

function showPreviousForm(step, from = "previous") {
  if (from !== "sidebar") {
    jQuery(`#prev-btn-loader-step-${step + 1}`).show()
    jQuery(`#prev-btn-content-step-${step + 1}`).hide()
  }

  if (from == "sidebar") {
    jQuery("#sidebar-menu").addClass("loading")
  }

  setTimeout(() => {
    setMultiformData(step, null, from)
  }, 200)
}

function submitForm(step) {
  var validatedForm = validateForm(step)
  if (!validatedForm) {
    return
  }

  if( isRecaptchaV3Active() && step == 1 ) {
    recaptchaV3Validation().then(function () {
      readyCurrentForm(step);
    }).catch(function (error) {
      console.error("Error during reCAPTCHA validation:", error);
    });
  } else {
    readyCurrentForm(step)
  }
}

function prefillForm(step = 1) {
  const storedData = getFromCookie(`form-step-${step}`)

  if (storedData) {
    var decode = decodeURIComponent(storedData)
    var formData = JSON.parse(decode)

    for (var key in formData) {
      if (key == "uuid") {
        continue
      }

      if (key == "g-recaptcha-response") {
        localStorage.setItem("recaptcha-response", formData[key])
        continue
      }

      const regex = /\[([^)]+)\]/
      const result = regex.exec(key)
      if( !result )  continue
      const field = result[1]
      const value = formData[key]

      if (field == "gender") {
        prefillGenderField(value)
        continue
      }

      if (field == "phone_plan") {
        prefillPhonePlanField(value)
        continue
      }

      if (field == "car_owner") {
        prefillCarOwnerField(value)
        continue
      }

      const dateFields = [
        "birth_date",
        "remuneration_deadline",
        "employment_start_date",
      ]

      if (dateFields.includes(field)) {
        prefillDateFields(field, value)
        continue
      }

      if (field == "bad_credit_history") {
        jQuery(`#form-step-${step} [name="${key}"]`).props("checked", true)
        continue
      }

      if (field == "occupation" && value == "EMPLOYED_INDEFINITE_PERIOD") {
        jQuery(".field-LeadForm-employment_start_date").show()
      }

      if (field == "occupation" && ["EMPLOYED_INDEFINITE_PERIOD", "ECONOMIC_ACTIVITY", "MATERNITY_LEAVE", "PENSIONER1"].includes(value)) {
        jQuery(".field-LeadForm-job_area").show()
      }

      var el = document.querySelector(`#form-step-${step} [name="${key}"]`)
      el.value = value
    }
  }
}

function prefillGenderField(value) {
  if (!value || value == "") {
    return
  }
  const button = jQuery(`#LeadForm-gender label.btn.${value}`)
  button.addClass("active")

  jQuery("#form-toggle-gender").val(value)
  return
}

function prefillPhonePlanField(value) {
  if (!value || value == "") {
    return
  }
  const button = jQuery(`#LeadForm-phone_plan label.btn.${value}`)
  button.addClass("active")

  jQuery("#form-toggle-phone_plan").val(value)
  return
}

function prefillCarOwnerField(value) {
  jQuery(".field-LeadForm-car_plate_number").hide()
  if (!value || value == "") {
    return
  }

  if( value == "YES" ) {
    jQuery(".field-LeadForm-car_plate_number").show()
  }
  const button = jQuery(`#LeadForm-car_owner label.btn.${value}`)
  button.addClass("active")

  jQuery("#LeadForm-car_owner").val(value)
  return
}

function prefillDateFields(field, value) {
  if (!value || value == "") {
    return
  }

  const split = value.split("-")
  document.querySelector(`#${field}-day`).value = split[0]
  document.querySelector(`#${field}-month`).value = split[1]
  document.querySelector(`#${field}-year`).value = split[2]

  return
}

function getFromStorage(name) {
  const item = window.localStorage.getItem(name)
  if (item === "undefined") {
    if (name === "transaction_id") {
      return 0
    }
    return "n/a"
  }

  return item
}

function getFromCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    return parts.pop().split(";").shift()
  }
}

function scrollToErrorElement() {
  var top = jQuery(".has-error").offset().top
  var height = jQuery("header.header").height()
  var el = jQuery([document.documentElement, document.body])
  el.animate({ scrollTop: top - height - 5 }, 2000)
}
